export default __webpack_public_path__ + "static/media/190629_190332_Joe Throwing Adam.e32c5576.jpg";